import { createSelector } from 'reselect'
import getItemsCartSelect from 'modules/cart/redux/selectors/get-items'
import isFullSizeVariantUtil from 'modules/variant/utils/is-full-size'

const getFullSizeItemsCartSelect = createSelector(
  getItemsCartSelect,
  (cartItems) => {
    return cartItems.filter(isFullSizeVariantUtil)
  }
)

export default getFullSizeItemsCartSelect
